import { render, staticRenderFns } from "./select_appointment_establishment.vue?vue&type=template&id=45c7ffbb&scoped=true"
import script from "./select_appointment_establishment.vue?vue&type=script&lang=js"
export * from "./select_appointment_establishment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c7ffbb",
  null
  
)

export default component.exports